module.exports = __webpack_public_path__ + "static/media/logo-white.6424d55a.svg";